import { IEvent } from './types';

export const sampleEvents: IEvent[] = [
  {
    id: '1',
    title: 'Welcome to the Gallery',
    description: 'An introduction to the Gallery app and its features.',
    videoURL: 'https://neuronation-med.de/videos/mci-video.mp4',
    thumbnailURL: 'https://picsum.photos/seed/1/300/200',
    pageURL: 'https://neuronation-med.de/cme/supporting-patients-with-mci',
    categories: ['Mild Cognitive Impairment', 'Cognitive difficulties', 'Age related'],
    quizURL: 'https://google-forms.com/mci-test',
    presenterImageURL: 'https://picsum.photos/seed/1/98/98',
    presenterName: 'Dr. John Doe',
    presenterDescription: 'Expert in cognitive health and rehabilitation.',
  },
  {
    id: '2',
    title: 'Understanding Mild Cognitive Impairment',
    description: 'A detailed overview of Mild Cognitive Impairment (MCI) and its implications.',
    videoURL: 'https://neuronation-med.de/videos/mci-overview.mp4',
    thumbnailURL: 'https://picsum.photos/seed/2/300/200',
    pageURL: 'https://neuronation-med.de/cme/supporting-patients-with-mci',
    categories: ['Mild Cognitive Impairment'],
    quizURL: 'https://google-forms.com/mci-overview-test',
    presenterImageURL: 'https://picsum.photos/seed/2/98/98',
    presenterName: 'Dr. Jane Smith',
    presenterDescription: 'Specialist in neurology and cognitive disorders.',
  },
  {
    id: '3',
    title: 'Cognitive Training for MCI',
    description: 'Exploring cognitive training techniques for patients with MCI.',
    videoURL: 'https://neuronation-med.de/videos/mci-training.mp4',
    thumbnailURL: 'https://picsum.photos/seed/3/300/200',
    pageURL: 'https://neuronation-med.de/cme/supporting-patients-with-mci',
    categories: ['Cognitive difficulties'],
    quizURL: 'https://google-forms.com/mci-training-test',
    presenterImageURL: 'https://picsum.photos/seed/3/98/98',
    presenterName: 'Dr. Emily White',
    presenterDescription: 'Renowned cognitive psychologist with a focus on MCI.',
  },
  {
    id: '4',
    title: 'Patient Support Strategies for seniors with MCI',
    description: 'Effective strategies for supporting patients with MCI.',
    videoURL: 'https://neuronation-med.de/videos/mci-support.mp4',
    thumbnailURL: 'https://picsum.photos/seed/4/300/200',
    pageURL: 'https://neuronation-med.de/cme/supporting-patients-with-mci',
    categories: ['Age related'],
    quizURL: 'https://google-forms.com/mci-support-test',
    presenterImageURL: 'https://picsum.photos/seed/4/98/98',
    presenterName: 'Dr. Mark Brown',
    presenterDescription: 'Geriatrician specializing in cognitive health.',
  },
  {
    id: '5',
    title: 'Latest Research on MCI',
    description: 'An overview of the latest research findings on Mild Cognitive Impairment.',
    videoURL: 'https://neuronation-med.de/videos/mci-research.mp4',
    thumbnailURL: 'https://picsum.photos/seed/5/300/200',
    pageURL: 'https://neuronation-med.de/cme/supporting-patients-with-mci',
    categories: ['Mild Cognitive Impairment', 'Cognitive difficulties'],
    quizURL: 'https://google-forms.com/mci-research-test',
    presenterImageURL: 'https://picsum.photos/seed/5/98/98',
    presenterName: 'Dr. Sarah Green',
    presenterDescription: 'Leading researcher in cognitive disorders and MCI.',
  },
  {
    id: '6',
    title: 'Cognitive Assessment Tools',
    description: 'Tools and methods for assessing cognitive function in patients with MCI.',
    videoURL: 'https://neuronation-med.de/videos/mci-assessment.mp4',
    thumbnailURL: 'https://picsum.photos/seed/6/300/200',
    pageURL: 'https://neuronation-med.de/cme/supporting-patients-with-mci',
    categories: ['Cognitive difficulties', 'Age related'],
    quizURL: 'https://google-forms.com/mci-assessment-test',
    presenterImageURL: 'https://picsum.photos/seed/6/98/98',
    presenterName: 'Dr. Lisa Blue',
    presenterDescription: 'Clinical psychologist with expertise in cognitive assessments.',
  },
  {
    id: '7',
    title: 'Cognitive Rehabilitation Techniques',
    description: 'An introduction to cognitive rehabilitation techniques for MCI patients.',
    videoURL: 'https://neuronation-med.de/videos/mci-rehabilitation.mp4',
    thumbnailURL: 'https://picsum.photos/seed/7/300/200',
    pageURL: 'https://neuronation-med.de/cme/supporting-patients-with-mci',
    categories: ['Mild Cognitive Impairment', 'Age related'],
    quizURL: 'https://google-forms.com/mci-rehabilitation-test',
    presenterImageURL: 'https://picsum.photos/seed/7/98/98',
    presenterName: 'Dr. Tom Yellow',
    presenterDescription: 'Expert in cognitive rehabilitation and therapy.',
  },
];
